import { eIcon } from "../../components/Icon";

const Party = {
  t1: eIcon.PLD,
  t2: eIcon.DRK,
  h1: eIcon.AST,
  h2: eIcon.SGE,
  m1: eIcon.DRG,
  m2: eIcon.SAM,
  r1: eIcon.SMN,
  r2: eIcon.MCH
}

export default Party;